export enum MismoAssetType {
	Unknown = "Unknown",
	RealEstateOwned = "RealEstateOwned",
	CheckingAccount = "CheckingAccount",
	GiftOfPropertyEquity = "GiftOfPropertyEquity",
	Bond = "Bond",
	BridgeLoanNotDeposited = "BridgeLoanNotDeposited",
	CertificateOfDepositTimeDeposit = "CertificateOfDepositTimeDeposit",
	IndividualDevelopmentAccount = "IndividualDevelopmentAccount",
	LifeInsurance = "LifeInsurance",
	MoneyMarketFund = "MoneyMarketFund",
	MutualFund = "MutualFund",
	RetirementFund = "RetirementFund",
	SavingsAccount = "SavingsAccount",
	Stock = "Stock",
	StockOptions = "StockOptions",
	TrustAccount = "TrustAccount",
	Other = "Other",
	CHECKING = 'CHECKING',
  SAVINGS = 'SAVINGS',
  MONEY_MARKET = 'MONEY_MARKET',
  CD = 'CD',
  INVESTMENT = 'INVESTMENT',
  RETIREMENT = 'RETIREMENT',
  REAL_ESTATE = 'REAL_STATE',
  OTHER = 'OTHER',
  GIFT_OF_CASH = 'GiftOfCash',
  GRANT = 'Grant',
}

export enum MismoResidencyType {
	Unknown = "Unknown",
	Current = "Current",
	Prior = "Prior"
}

export enum MismoResisdencyTypeBasis {
	Unknown = "Unknown",
	Own = "Own",
	Rent = "Rent",
	LivinRentFree = "LivingRentFree"
}

export enum MismoOwnedPropertyDispositionStatusType {
	Unknown = "Unknown",
	Retained = 'Retained',
	PendingSale = 'PendingSale',
	Sold = 'Sold',
}

export enum MismoPropertyUsageType {
	Unknown = "Unknown",
	Investment = 'Investment',
	PrimaryResidence = 'PrimaryResidence',
	SecondHome = 'SecondHome'
}

export enum  MismoApplicationTakenMethodType {
	Unknown = "Unknown",
	FaceToFace = 'FaceToFace',
	Telephone = 'Telephone',
	Fax = 'Fax',
	Internet = 'Internet',
	LeaveBlank = 'LeaveBlank'
}

export enum MismoIncomeSourceType {
	Unknown = "Unknown",
	Alimony = 'Alimony',
	AutomobileAllowance = 'AutomobileAllowance',
	BoarderIncome = 'BoarderIncome',
	CapitalGains = 'CapitalGains',
	ChildSupport = 'ChildSupport',
	DefinedContributionPlan = 'DefinedContributionPlan',
	Disability = 'Disability',
	DividendsInterest = 'DividendsInterest',
	FosterCare = 'FosterCare',
	HousingAllowance = 'HousingAllowance',
	MortgageCreditCertificate = 'MortgageCreditCertificate',
	MortgageDifferential = 'MortgageDifferential',
	NotesReceivableInstallment = 'NotesReceivableInstallment',
	Other = 'Other',
	Pension = 'Pension',
	PublicAssistance = 'PublicAssistance',
	Royalties = 'Royalties',
	SeparateMaintenance = 'SeparateMaintenance',
	SocialSecurity = 'SocialSecurity',
	Trust = 'Trust',
	Unemployment = 'Unemployment',
	VABenefitsNonEducational = 'VABenefitsNonEducational',
	JobRelatedExpenses = 'JobRelatedExpenses',
	SeparateMaintenanceExpense = 'SeparateMaintenanceExpense',
}

export enum MismoMaritalStatus {
	Married = 'Married',
	Separated = 'Separated',
	Unmarried = 'Unmarried',
	Divorced = 'Divorced',
	Widowed = 'Widowed',
}

export enum MismoCitizenshipResidencyType {
	U_S_CITIZEN = 'U_S_CITIZEN',
	PERMANENT_RESIDENT = 'PERMANENT_RESIDENT',
	NON_PERMANENT_RESIDENT = 'NON_PERMANENT_RESIDENT',
}

export enum MismoGiftOrGrantSourceType {
	RELATIVE = 'Relative',
	EMPLOYER = 'Employer',
	OTHER = 'Other'
}

export enum MismoLiabilityType {
	UNKNOWN = 'Uknown',
	MORTGAGE = 'MortgageLoan',
	HELOC = 'HELOC',
	CAR_LOAN = 'CarLoan',
	STUDENT_LOAN = 'StudentLoan',
	CREDIT_CARD = 'CreditCard',
	OTHER = 'Other'
}

export enum MismoMortgageType {
	CONVENTIONAL = 'Conventional',
	FHAN = 'FHA',
	VA = 'VA',
	USDARuralDevelopment = 'USDARuralDevelopment',
	OTHER = 'Other'
}

export enum MismoMilitaryStatus {
	ACTIVE_DUTY = 'ActiveDuty',
	RESERVE_NATIONAL_GUARD_NEVER_ACTIVATED = 'ReserveNationalGuardNeverActivated',
	VETERAN = 'Veteran'
}

export enum MismoOwnershipShareOptions {
	NONE = 'None',
	LESS_THAN_25 = 'LessThan25Percent',
	MORE_THAN_25 = 'MoreThan25Percent',
}

export enum MismoHouseExpenseType {
	HOME_OWNERS_INSURANCE = 'HomeownersInsurance',
	REAL_ESTATE_TAX = 'RealEstateTax',
	OTHER = 'OTHER'
}

export enum MismoHousingExpenseTimingType {
	PROPOSED = 'Proposed'
}

export enum MismoHousingExpenseType {
  FIRST_MORTGAGE_PRINCIPAL_AND_INTEREST= 'FirstMortgagePrincipalAndInterest',
  HOMEOWNERS_INSURANCE= 'HomeownersInsurance',
  REAL_ESTATE_TAX = 'RealEstateTax',
	MI_PREMIUM = 'MIPremium',
	OTHER_MORTGAGE_LOAN_PRINCIPAL_AND_INTEREST = 'OtherMortgageLoanPrincipalAndInterest',
	HOMEOWNERS_ASSOCIATION_DUES_AND_CONDOMINIUM_FEES = 'HomeownersAssociationDuesAndCondominiumFees',
  OTHER = 'Other'
}

export interface MismoResidenceAddress {
	AddressLineText: string;
	CityName: string;
	CountryCode: string;
	PostalCode: string;
	StateCode: string;
};
export interface MismoResidenceDetail {
	BorrowerResidencyBasisType?: string;
	BorrowerResidencyDurationMonthsCount: string;
	BorrowerResidencyStartDate?: string;
	BorrowerResidencyEndDate?: string;
	BorrowerResidencyType?: string;
};

export interface MismoResidenceData {
	ADDRESS: MismoResidenceAddress,
	RESIDENCE_DETAIL: MismoResidenceDetail,
	LANDLORD: {
		LANDLORD_DETAIL: {
			MonthlyRentAmount?: string
		}
	}
}

export interface BorrowerEmployment {
  _id: string;
  employerName: string;
  position: string;
  startDate: Date;
  endDate: Date;
  phone: string;
  isEmployedByFamilyMember: boolean;
  isBusinessOwner: boolean;
  employmentStatus: string;
  monthlyIncome: {
    base: string | number;
    overtime: string | number;
    bonus: string | number;
    commission: string | number;
    military: string | number;
    other: string | number;
  };
  address: {
    street: string;
    unit: string;
    city: string;
    state: string;
    zip: string;
    country: string;
  };
}

export interface MismoRelation {
	SequenceNumber: string;
	"xlink:arcrole": string;
	"xlink:from": string;
	"xlink:to": string;
}
export interface MismoXMLUpload {
	// DEAL_SETS: {
		DEAL_SET: {
				DEALS: {
						DEAL: {
								ASSETS: {
										ASSET: Array<{
												SequenceNumber: string;
												'xlink:label': string;
												ASSET_DETAIL: {
														AssetCashOrMarketValueAmount: string;
														AssetType: string;
														AssetAccountIdentifier?: string;
														AssetTypeOtherDescription?: string;
														FundsSourceType?: string;
														EXTENSION?: {
																OTHER: {
																		'ULAD:ASSET_DETAIL_EXTENSION': {
																				'ULAD:IncludedInAssetAccountIndicator': string;
																		};
																};
														};
												};
												OWNED_PROPERTY?: {
														OWNED_PROPERTY_DETAIL: {
																OwnedPropertyDispositionStatusType: string;
																OwnedPropertyMaintenanceExpenseAmount: string;
																OwnedPropertySubjectIndicator: string;
																OwnedPropertyLienInstallmentAmount?: string;
																OwnedPropertyLienUPBAmount?: string;
																OwnedPropertyRentalIncomeGrossAmount?: string;
																OwnedPropertyRentalIncomeNetAmount?: string;
														};
														PROPERTY: {
																ADDRESS: {
																		AddressLineText: string;
																		CityName: string;
																		CountryCode: string;
																		PostalCode: string;
																		StateCode: string;
																};
																PROPERTY_DETAIL: {
																		PropertyCurrentUsageType: string;
																		PropertyEstimatedValueAmount: string;
																		PropertyUsageType: string;
																};
														};
												};
												ASSET_HOLDER?: {
														NAME: {
																FullName: string;
														};
												};
										}>;
								};
								COLLATERALS: {
										COLLATERAL: {
												SUBJECT_PROPERTY: {
														ADDRESS: {
															AddressLineText: string;
															CityName: string;
															CountryCode: string;
															PostalCode: string;
															StateCode: string;
															CountyName: string;
														},
														PROPERTY_DETAIL: {
																FinancedUnitCount: string;
																PropertyEstimatedValueAmount: string;
																PropertyUsageType: string;
																PUDIndicator: string;
																RentalEstimatedGrossMonthlyRentAmount: Boolean;
																FHASecondaryResidenceIndicator: Boolean;
																ConstructionMethodType: string;
																RentalEstimatedNetMonthlyRentAmount: string;
														};
														SALES_CONTRACTS: {
																SALES_CONTRACT: {
																		SALES_CONTRACT_DETAIL: {
																				SalesContractAmount: string;
																		};
																};
														};
														PROPERTY_VALUATIONS: {
															PROPERTY_VALUATION: {
																PROPERTY_VALUATION_DETAIL: {
																	PropertyValuationAmount: string;
																}
															}
														}
												};
										};
								};
								LOANS: {
										LOAN: {
												LoanRoleType: string;
												'xlink:label': string;
												DOCUMENT_SPECIFIC_DATA_SETS: {
														DOCUMENT_SPECIFIC_DATA_SET: {
																URLA: {
																		URLA_DETAIL: {
																				BorrowerRequestedLoanAmount: string;
																		};
																};
														};
												};
												LOAN_DETAIL: {
														BalloonIndicator: string;
														BorrowerCount: string;
														ConstructionLoanIndicator: string;
														InterestOnlyIndicator: string;
														PrepaymentPenaltyIndicator: string;
														TotalMortgagedPropertiesCount: string;
												};
												LOAN_IDENTIFIERS: {
														LOAN_IDENTIFIER: {
																LoanIdentifier: string;
																LoanIdentifierType: string;
														};
												};
												TERMS_OF_LOAN: {
														BaseLoanAmount: string;
														LoanPurposeType: string;
														NoteRatePercent: string;
												};
												HOUSING_EXPENSES: {
													HOUSING_EXPENSE: {
														HousingExpensePaymentAmount: string;
														HousingExpenseTimingType: string;
														HousingExpenseType: string;
													}
												}
										};
								};
								PARTIES: {
										PARTY: Array<{
												INDIVIDUAL: {
														ALIASES?: {
																ALIAS: Array<{
																		NAME: {
																				FirstName: string;
																				MiddleName: string;
																				LastName: string;
																				SuffixName: string;
																		};
																}>;
														};
														CONTACT_POINTS: {
																CONTACT_POINT: Array<{
																		CONTACT_POINT_TELEPHONE?: {
																				ContactPointTelephoneValue: string;
																				ContactPointTelephoneExtensionValue?: string;
																		};
																		CONTACT_POINT_EMAIL?: {
																				ContactPointEmailValue: string;
																		};
																		CONTACT_POINT_DETAIL?: {
																				ContactPointRoleType: string;
																		};
																}>;
														};
														NAME: {
																FirstName: string;
																MiddleName: string;
																LastName: string;
																SuffixName: string;
														};
														LANGUAGES?: {
																LANGUAGE: {
																		LanguageCode: string;
																		EXTENSION: {
																				OTHER: {
																						'ULAD:LANGUAGE_EXTENSION': {
																								'ULAD:LanguageRefusalIndicator': string;
																						};
																				};
																		};
																};
														};
														BANKRUPTCIES?: {
																BANKRUPTCY: Array<{
																		BANKRUPTCY_DETAIL: {
																				BankruptcyChapterType: string;
																		};
																}>;
														};
														COUNSELING?: {
																COUNSELING_EVENTS: {
																		COUNSELING_EVENT: Array<{
																				SequenceNumber: string;
																				'xlink:label': string;
																				COUNSELING_EVENT_DETAIL: {
																						CounselingCompletedDate?: string;
																						CounselingConfirmationIndicator: string;
																						CounselingFormatType?: string;
																						CounselingType: string;
																				};
																		}>;
																};
														};
														CURRENT_INCOME?: {
																CURRENT_INCOME_ITEMS: {
																		CURRENT_INCOME_ITEM: Array<{
																				SequenceNumber: string;
																				'xlink:label': string;
																				CURRENT_INCOME_ITEM_DETAIL: {
																						CurrentIncomeMonthlyTotalAmount: string;
																						EmploymentIncomeIndicator: string;
																						IncomeType: string;
																				};
																		}>;
																};
														};
														MILITARY_SERVICES?: {
																MILITARY_SERVICE: {
																		MilitaryStatusType: string;
																};
														};
												};
												ADDRESSES: {
													ADDRESS: {
														AddressLineText: string,
														AddressType: string,
														CityName: string,
														CountryCode: string,
														PostalCode: string,
														StateCode: string,
													}
												}
												ROLES: {
														ROLE: {
																SequenceNumber: string;
																'xlink:label': string;
																LICENSES?: {
																		LICENSE: {
																				LICENSE_DETAIL: {
																						LicenseAuthorityLevelType: string;
																						LicenseIdentifier: string;
																				};
																		};
																};
																BORROWER?: {
																		BORROWER_DETAIL: {
																				BorrowerBirthDate: string;
																				BorrowerClassificationType: string;
																				DependentCount?: string;
																				MaritalStatusType: string;
																				SelfDeclaredMilitaryServiceIndicator: string;
																				SpousalVABenefitsEligibilityIndicator: string;
																				CitizenshipResidencyType?: string;
																		};
																		DECLARATION: {
																				DECLARATION_DETAIL: {
																						BankruptcyIndicator: string;
																						CitizenshipResidencyType: string;
																						FHASecondaryResidenceIndicator: string;
																						HomeownerPastThreeYearsType: string;
																						IntentToOccupyType: string;
																						OutstandingJudgmentsIndicator: string;
																						PartyToLawsuitIndicator: string;
																						PresentlyDelinquentIndicator: string;
																						PriorPropertyDeedInLieuConveyedIndicator: string;
																						PriorPropertyForeclosureCompletedIndicator: string;
																						PriorPropertyShortSaleCompletedIndicator: string;
																						PriorPropertyTitleType: string;
																						PriorPropertyUsageType: string;
																						PropertyProposedCleanEnergyLienIndicator: string;
																						UndisclosedBorrowedFundsAmount: string;
																						UndisclosedBorrowedFundsIndicator: string;
																						UndisclosedComakerOfNoteIndicator: string;
																						UndisclosedCreditApplicationIndicator: string;
																						UndisclosedMortgageApplicationIndicator: string;
																						EXTENSION: {
																								OTHER: {
																										DECLARATION_DETAIL_EXTENSION: {
																												SpecialBorrowerSellerRelationshipIndicator: string;
																										};
																								};
																						};
																				};
																		};
																		EMPLOYERS?: {
																				EMPLOYER: Array<{
																						SequenceNumber: string;
																						'xlink:label': string;
																						LEGAL_ENTITY: {
																								LEGAL_ENTITY_DETAIL: {
																										FullName: string;
																								};
																								CONTACTS: {
																									CONTACT: {
																										CONTACT_POINTS: {
																											CONTACT_POINT: Array<{
																													CONTACT_POINT_TELEPHONE: {
																															ContactPointTelephoneValue: string;
																													};
																											}>;
																										};
																									};
																								};

																						};
																						ADDRESS: {
																								AddressLineText: string;
																								CityName: string;
																								CountryCode: string;
																								PostalCode: string;
																								StateCode: string;
																						};
																						EMPLOYMENT: {
																								EmploymentBorrowerSelfEmployedIndicator: string;
																								EmploymentClassificationType: string;
																								EmploymentMonthlyIncomeAmount: string;
																								EmploymentPositionDescription: string;
																								EmploymentStartDate: string;
																								EmploymentStatusType: string;
																								EmploymentTimeInLineOfWorkMonthsCount: string;
																						};
																				}>;
																		};
																		RESIDENCES: {
																				RESIDENCE: Array<{
																						ADDRESS: MismoResidenceAddress;
																						RESIDENCE_DETAIL: MismoResidenceDetail;
																						LANDLORD: {
																							LANDLORD_DETAIL: {
																								MonthlyRentAmount?: string
																							}
																						}
																				}>;
																		};
																		DEPENDENTS?: {
																			DEPENDENT: Array<{
																					DependentAgeYearsCount: string;
																			}>;
																		};
																		GOVERNMENT_MONITORING: {
																			GOVERNMENT_MONITORING_DETAIL: {
																				HMDAEthnicityRefusalIndicator: string;
																				HMDAGenderRefusalIndicator: string;
																				HMDARaceRefusalIndicator: string;
																				HMDAEthnicityCollectedBasedOnVisualObservationOrSurnameIndicator: string;
																				HMDAGenderCollectedBasedOnVisualObservationOrSurnameIndicator: string;
																				HMDARaceCollectedBasedOnVisualObservationOrSurnameIndicator: string;
																				EXTENSION: {
																					OTHER: {
																						GOVERNMENT_MONITORING_DETAIL_EXTENSION: {
																							ApplicationTakenMethodType: string;
																							HMDAGenderType: string;
																						};
																					};
																				};
																			};
																			HMDA_ETHNICITY_ORIGINS?: {
																				HMDA_ETHNICITY_ORIGIN: Array<{
																					HMDAEthnicityOriginType: string;
																					HMDAEthnicityOriginTypeOtherDescription?: string;
																				}>;
																			};
																			HMDA_RACES: {
																				HMDA_RACE: Array<{
																					HMDA_RACE_DESIGNATIONS?: {
																						HMDA_RACE_DESIGNATION: Array<{
																							EXTENSION: {
																								OTHER: {
																									HMDA_RACE_DESIGNATION_EXTENSION: {
																										HMDARaceDesignationType: string;
																										HMDARaceDesignationOtherAsianDescription?: string;
																										HMDARaceDesignationOtherPacificIslanderDescription?: string;
																									};
																								};
																							};
																						}>;
																					};
																					HMDA_RACE_DETAIL: {
																						HMDARaceType: string;
																						HMDARaceTypeAdditionalDescription?: string;
																					};
																				}>;
																			};
																			EXTENSION: {
																				OTHER: {
																					GOVERNMENT_MONITORING_EXTENSION: {
																						HMDA_ETHNICITIES: {
																							HMDA_ETHNICITY: Array<{
																								HMDAEthnicityType: string;
																							}>;
																						};
																					};
																				};
																			};
																		};
																		HOUSING_EXPENSES: {
																			HOUSING_EXPENSE: Array<{
																				HousingExpensePaymentAmount: string;
																				HousingExpenseTimingType: string;
																				HousingExpenseType: string;
																			}>;
																		}
																		CURRENT_INCOME: {
																			CURRENT_INCOME_ITEMS: {
																				CURRENT_INCOME_ITEM: Array<{
																					SequenceNumber: string;
																					'xlink:label': string;
																					CURRENT_INCOME_ITEM_DETAIL: {
																						CurrentIncomeMonthlyTotalAmount: string;
																						IncomeType: string;
																						EmploymentIncomeIndicator: Boolean;
																					};
																				}>;
																			};
																		};
																		MILITARY_SERVICES?: {
																			MILITARY_SERVICE: {
																				MilitaryStatusType: string;
																				MilitaryServiceExpectedCompletionDate: string;
																			}
																		}
																};
																ROLE_DETAIL: {
																		PartyRoleType: string;
																};
														};
												};
												TAXPAYER_IDENTIFIERS?: {
														TAXPAYER_IDENTIFIER: {
																TaxpayerIdentifierType: string;
																TaxpayerIdentifierValue?: string;
														};
												};
												LEGAL_ENTITY?: {
														LEGAL_ENTITY_DETAIL: {
																FullName: string;
														};
														CONTACTS?: {
																CONTACT: {
																		CONTACT_POINTS: {
																				CONTACT_POINT: Array<{
																						CONTACT_POINT_TELEPHONE: {
																								ContactPointTelephoneValue: string;
																						};
																				}>;
																		};
																};
														};
												};
												LICENSES?: {
														LICENSE: {
																LICENSE_DETAIL: {
																		LicenseAuthorityLevelType: string;
																		LicenseIdentifier: string;
																};
														};
												};
										}>;
								};
								RELATIONSHIPS: {
										RELATIONSHIP: Array<{
												SequenceNumber: string;
												'xlink:arcrole': string;
												'xlink:from': string;
												'xlink:to': string;
										}>;
								};
								EXPENSES: {
										EXPENSE: Array<{
												SequenceNumber: string;
												'xlink:label': string;
												ExpenseMonthlyPaymentAmount: string;
												ExpenseType: string;
										}>;
								};
								LIABILITIES: {
										LIABILITY: Array<{
												SequenceNumber: string;
												'xlink:label': string;
												LIABILITY_DETAIL: {
														LiabilityAccountIdentifier: string;
														LiabilityMonthlyPaymentAmount: string;
														LiabilityPayoffStatusIndicator: string;
														LiabilityType: string;
														LiabilityUnpaidBalanceAmount: string;
														MortgageType?: string;
												};
												LIABILITY_HOLDER: {
														NAME: {
																FullName: string;
														};
												};
										}>;
								};
						};
				};
		};
	// };
}
